module.exports = __webpack_public_path__ + "img/yjk01.03b9374b.png";